import { API_PROCEDURE_CREATE } from "../config";
import httpClient from "../httpClient";

const createProcedure = {
    create: (data) => httpClient.post(API_PROCEDURE_CREATE, data),
};

export default createProcedure;
